import { ref } from "vue"

//POST API
export async function postAPI(url, apiData) 
{
	try
	{
		let data = await fetch(url, { method: "POST", body: JSON.stringify(apiData)}) 
		const result = await data.json()
		return result
	}
	catch (err)
	{ console.log(err)}	
}

//GET API
export async function getAPI(url) 
{
	try
	{
		let data = await fetch(url) 
		const result = await data.json()
		return result
	}
	catch (err)
	{ console.log(err)}	
}


//Currency Format
export function currencyFormat(num, decimal = 0) 
{
	if(num != null && num != '')
		num = parseFloat(num).toFixed(decimal).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	else
		num = 0
	return num
}

//Currency Date
export function dateFormat(input) 
{
	var date = new Date(input);
	let yyyy = date.getFullYear();
	let mm = date.toLocaleString('default', { month: 'short' }); 
	let dd = date.getDate();
	return dd+' '+mm+' '+yyyy
}


//Date Format
function validateDateInput(id)
{ 	
	var input = document.getElementById(id).value;
	
	if( input.length > 0)
    {
		if(!validateDate(input))
			return raiseError(id);
		else
		{
			return resetForm(id);
		}
	}
	else
        return resetForm(id);
}


//Email Format
function validateEmailAddress(id)
{ 	
	var emailCell = id.value;
	
	if(emailCell.length > 0)
    {
		if(!validateEmail(emailCell))
			return raiseError(id);
		else
		{
			return resetForm(id);
		}
	}
	else
		return resetForm(id);
}


//VALIDATION
export function validateText(id)
{
	var input = document.getElementById(id).value;

    if(input.length > 0)
    {		
		if(!validateString(input) || input.length <= 1)
			return raiseError(id);	
		else
		{
			return resetForm(id);
		}
	}
	else
        return resetForm(id);
}

export function validatePostcode(id)
{
	var postcode = document.getElementById(id).value;
	
	if(postcode.length > 0)
    {	
		if(!validateNumber(postcode) || postcode.length !== 4)
			return raiseError(id);	
		else
		{
			return resetForm(id);
		}
	}
	else
		return resetForm(id);
}

export function validateAmount(id)
{
	var amountCell = document.getElementById(id).value,
	amount = (amountCell != null && amountCell != "" ? amountCell.replace(/[$,]/g,"") : "")
	
	if(amount.length > 0)
    {
		amount = parseInt(amount).toFixed(0);
		if(!validateNumber(amount) || amount.length < 1)
			return raiseError(id);
		else
		{
			document.getElementById(id).value = currencyFormat(amount);
			return resetForm(id);
		}
	}
	else
	{
		document.getElementById(id).value = currencyFormat(amount);
        return resetForm(id);
	}
}

export function validateNumber(input) //function to validate string inputs 
{
    var integarRegEx = /^([0-9]+)?$/;
	
    if(input.length > 0)
    {
        if(input == "" || !integarRegEx.test(input))
            return false;
        else
            return true;
    }
	else
        return true;
}

function validateString(input) //function to validate string inputs 
{
	var stringRegEx = /^[A-Za-z\s]+$/;
	
    if(input.length > 0)
    {
        if(input == "" || !stringRegEx.test(input))
            return false;
        else
            return true;
    }
	else
        return true;
}

function resetForm(element)
{
	document.getElementById(element).style = 'border: 1px solid #F1EDEE';
}

function raiseError(element)
{
	document.getElementById(element).style = "border: 1px solid #DB5461";
}

export async function authenticate(code)
{
	var data = { msc : code }
	return await postAPI('https://pazo.com.au/api/webservice.php?operation=authenticate', data)
}

export function getBrokerCode()
{ 
	var key = localStorage.msc
	var code = key.split('$-')
	return code[0]
}

export async function countAccounts(code)
{
	var data = { id_broker : code }
	var result = await postAPI('https://pazo.com.au/api/webservice.php?operation=PortfolioReport&type=count', data)
	return result
}

export async function getLogos(code)
{
	var data = { id_broker : code }
	var result = await postAPI('https://pazo.com.au/api/webservice.php?operation=getPortfolioLenders', data)
	return result
}

export function switchInput(item)
{
	if(document.getElementById(item).style.display === "none")
		document.getElementById(item).style.display = "contents";
	else
		document.getElementById(item).style.display = "none";
}